import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import usePortal from 'react-useportal';
import { getCoords } from '../../utils';
import { Coords, FiasSearchProps } from '../../types';
import { SelectWrapper } from './search.styled';
import { Control, MenuList } from './components';

type SearchProps = {
  menuOpen: boolean;
  setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
} & Pick<
  FiasSearchProps,
  'flat' | 'selectOnlyHouses' | 'withSectors' | 'isDisabled' | 'disabledHouses'
>;

export const Search: FC<SearchProps> = observer(
  ({
    flat,
    menuOpen,
    setMenuOpen,
    selectOnlyHouses,
    withSectors,
    isDisabled,
    disabledHouses,
  }) => {
    const [coords, setCoords] = useState<Coords | null>(null);
    const { Portal, isOpen, openPortal, closePortal, ref } = usePortal({
      onClose: () => setMenuOpen(false),
    });

    useEffect(() => {
      if (menuOpen && ref.current) {
        const coords = getCoords(ref.current);
        setCoords(coords);
      }
    }, [menuOpen]);

    return (
      <SelectWrapper ref={ref}>
        <Control
          openMenu={menuOpen}
          setMenuOpen={setMenuOpen}
          openPortal={openPortal}
          closePortal={closePortal}
          withSectors={withSectors}
          isDisabled={isDisabled}
        />
        {isOpen && coords && (
          <Portal>
            <MenuList
              flat={flat}
              openMenu={menuOpen}
              selectOnlyHouses={selectOnlyHouses}
              coords={coords}
              closePortal={closePortal}
              withSectors={withSectors}
              disabledHouses={disabledHouses}
            />
          </Portal>
        )}
      </SelectWrapper>
    );
  }
);
